// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { checkoutContentWrapperStyles } from "@guestsupply/App/Components/Checkout/CheckoutContentWrapper";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

checkoutContentWrapperStyles.container = {
    css: css`
        border: 1px solid ${getColor("common.border")};
        border-radius: 4px;
    `,
};

checkoutContentWrapperStyles.contentWrapper = {
    css: css`
        padding: 16px;
        ${({ isReview }: any) => isReview && "padding-bottom: 0;"}
    `,
};

checkoutContentWrapperStyles.titleText = {
    variant: "h3",
    as: "p",
    css: css`
        margin: 0;
    `,
};

checkoutContentWrapperStyles.titleWrapper = {
    css: css`
        padding: 12px 16px;
        border-bottom: 1px solid ${getColor("common.border")};
        background-color: ${getColor("common.ui2")};
    `,
};
